define("shared/components/shared/social/linkedin-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "rsvp", "tracked-built-ins", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _rsvp, _trackedBuiltIns, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"rsvp",0,"tracked-built-ins",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} {{did-insert (perform this.fetchUserData)}} as |modal|>
    <modal.card>
      <modal.card-header>
        <p class="o--modalHeader__title"> {{t "linkedin.select_profile_title"}} </p>
      </modal.card-header>
      <modal.card-body class="has--scroll">
        {{#if this.isRunning}}
          <div class="cLB--container">
            <Shared::LoadingSpinner />
          </div>
        {{else}}
          {{#if this.profile}}
            <p class="u--text--bold u--m__b__sm u--m__t__lg"> {{t "linkedin.personal_profile"}} </p>
            <div class="u--row u--m__tb">
              <div class="u--col__6">
                <Shared::Ui::Button
                  @additional="block"
                  @class="o--btn--selectable u--inline {{if
                    (eq this.selectedOrganizationOrProfile.id this.profile.id)
                    'is--selected'
                  }}"
                  @onClick={{(fn this.selectOrganizationOrProfile this.profile)}}
                  @variant="outline"
                >
                  <div class="o--user">
                    <img class="o--user__avatar is--square" src={{this.profile.avatar_url}} />
                    <span class="o--user__title u--p__t__sm">{{this.profile.name}}</span>
                  </div>
                </Shared::Ui::Button>
              </div>
            </div>
          {{/if}}
  
          {{#if this.organizations}}
            <p class="u--text--bold u--m__b__sm u--m__t__lg"> {{t "linkedin.pages"}} </p>
            <div class="u--row u--m__tb">
              {{#each this.organizations as |organization|}}
                <div class="u--col__6">
                  <Shared::Ui::Button
                    @additional="block"
                    @class="o--btn--selectable o--btn--block u--inline {{if
                      (eq this.selectedOrganizationOrProfile.id organization.id)
                      'is--selected'
                    }}"
                    @onClick={{(fn this.selectOrganizationOrProfile organization)}}
                    @variant="outline"
                  >
                    <div class="o--user">
                      <img class="o--user__avatar is--square" src={{organization.avatar_url}} />
                      <span class="o--user__title u--p__t__sm">{{organization.name}}</span>
                    </div>
                  </Shared::Ui::Button>
                </div>
              {{/each}}
            </div>
          {{/if}}
          <p class="u--m__t__lg">
            {{t "linkedin.select_profile_note"}}
            <Shared::Link
              @href="https://help.later.com/hc/articles/360063905933"
              @text={{t "shared_phrases.learn_more"}}
            />
          </p>
        {{/if}}
      </modal.card-body>
  
      <modal.card-footer class="o--modalFooter">
        <div class="o--btnBar">
          <Shared::Ui::Button
            @class="u--float--left"
            @onClick={{@handleClose}}
            @text={{t "shared_words.cancel"}}
            @variant="outline"
          />
          <Shared::Ui::Button
            @class="u--float--right"
            @isDisabled={{this.buttonIsDisabled}}
            @onClick={{perform @addLinkedinProfile this.selectedOrganizationOrProfile.id}}
            @text={{t "account.controllers.social_profiles.new.add_profile"}}
            @variant="primary"
          />
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "yjBt4Ff2",
    "block": "[[[8,[39,0],[[4,[38,1],[[28,[37,2],[[30,0,[\"fetchUserData\"]]],null]],null]],[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.select_profile_title\"],null]],[1,\" \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"has--scroll\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isRunning\"]],[[[1,\"        \"],[10,0],[14,0,\"cLB--container\"],[12],[1,\"\\n          \"],[8,[39,5],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"profile\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--bold u--m__b__sm u--m__t__lg\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.personal_profile\"],null]],[1,\" \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--m__tb\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,6],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[29,[\"o--btn--selectable u--inline \",[52,[28,[37,7],[[30,0,[\"selectedOrganizationOrProfile\",\"id\"]],[30,0,[\"profile\",\"id\"]]],null],\"is--selected\"]]],[28,[37,8],[[30,0,[\"selectOrganizationOrProfile\"]],[30,0,[\"profile\"]]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                  \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,0,[\"profile\",\"avatar_url\"]]],[12],[13],[1,\"\\n                  \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,[30,0,[\"profile\",\"name\"]]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"organizations\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--bold u--m__b__sm u--m__t__lg\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.pages\"],null]],[1,\" \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--m__tb\"],[12],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"organizations\"]]],null]],null],null,[[[1,\"              \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[8,[39,6],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[29,[\"o--btn--selectable o--btn--block u--inline \",[52,[28,[37,7],[[30,0,[\"selectedOrganizationOrProfile\",\"id\"]],[30,3,[\"id\"]]],null],\"is--selected\"]]],[28,[37,8],[[30,0,[\"selectOrganizationOrProfile\"]],[30,3]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n                  \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                    \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,3,[\"avatar_url\"]]],[12],[13],[1,\"\\n                    \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,[30,3,[\"name\"]]],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[3]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,2],[14,0,\"u--m__t__lg\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"linkedin.select_profile_note\"],null]],[1,\"\\n          \"],[8,[39,11],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/360063905933\",[28,[37,3],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],[[24,0,\"o--modalFooter\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--left\",[30,1],[28,[37,3],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n        \"],[8,[39,6],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--right\",[30,0,[\"buttonIsDisabled\"]],[28,[37,2],[[30,4],[30,0,[\"selectedOrganizationOrProfile\",\"id\"]]],null],[28,[37,3],[\"account.controllers.social_profiles.new.add_profile\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\",\"organization\",\"@addLinkedinProfile\"],false,[\"shared/modal\",\"did-insert\",\"perform\",\"t\",\"if\",\"shared/loading-spinner\",\"shared/ui/button\",\"eq\",\"fn\",\"each\",\"-track-array\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/social/linkedin-modal.hbs",
    "isStrictMode": false
  });
  let LinkedInModalComponent = _exports.default = (_class = class LinkedInModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "cache", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "linkedin", _descriptor3, this);
      _initializerDefineProperty(this, "organizations", _descriptor4, this);
      _initializerDefineProperty(this, "profile", _descriptor5, this);
      _initializerDefineProperty(this, "selectedOrganizationOrProfile", _descriptor6, this);
      _defineProperty(this, "fetchUserData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const getProfilePromise = this.linkedin.fetchLinkedinProfile.perform();
          const getOrganizationsPromise = this.linkedin.fetchLinkedinOrganizations.perform();
          const settledPromises = yield (0, _rsvp.allSettled)([getProfilePromise, getOrganizationsPromise]);
          this.profile = this._parseSettledPromise(settledPromises[0]);
          this.organizations = new _trackedBuiltIns.TrackedArray(this._parseSettledPromise(settledPromises[1]));
        }
      }), null, "fetchUserData", null));
    }
    get buttonIsDisabled() {
      return !this.selectedOrganizationOrProfile || this.isRunning;
    }
    get isRunning() {
      return this.fetchUserData.isRunning || this.args.addLinkedinProfile.isRunning;
    }
    handleClose() {
      this.cache.remove('linkedin_selected_social_identity_id');
      this.args.handleClose();
    }
    selectOrganizationOrProfile(organizationOrProfile) {
      if (this.selectedOrganizationOrProfile?.id === organizationOrProfile.id) {
        this.selectedOrganizationOrProfile = undefined;
      } else {
        this.selectedOrganizationOrProfile = organizationOrProfile;
      }
    }
    _parseSettledPromise(_ref) {
      let {
        state,
        reason,
        value
      } = _ref;
      if (state === 'fulfilled') {
        return value;
      } else if (state === 'rejected') {
        const {
          error
        } = reason;
        this.errors.log(error);
        return;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkedin", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "organizations", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedArray([]);
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "profile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedOrganizationOrProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectOrganizationOrProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectOrganizationOrProfile"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LinkedInModalComponent);
});